import {
  Box,
  FormControl,
  TextField,
  TextFieldProps,
  Tooltip,
} from "@mui/material";
import { blockInvalidChar } from "utils/common";
import { InfolconIcon } from "./Icons";

interface GKTextFieldProps {
  inputLabel?: string;
  requiredField?: boolean;
  loading?: boolean;
  blockChar?: boolean;
  tooltipTitle?: string;
  placeholder?: string;
}

const GKTextField = (props: GKTextFieldProps & TextFieldProps) => {
  const {
    inputLabel,
    id,
    name,
    loading,
    requiredField,
    type,
    placeholder,
    fullWidth = true,
    tooltipTitle,
    blockChar = true,
    slotProps,
    disabled,
    ...rest
  } = props;

  return (
    <FormControl variant="standard" fullWidth={fullWidth}>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <TextField
          {...rest}
          id={id}
          fullWidth
          name={name}
          label={inputLabel}
          type={type || ""}
          disabled={disabled || loading}
          placeholder={placeholder || inputLabel || "Enter"}
          onKeyDown={(e) => {
            blockChar && props?.type === "number" && blockInvalidChar(e);
            if (
              ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(
                e.key,
              )
            ) {
              e.stopPropagation();
            }
          }}
          onWheel={(e: any) => e.target.blur()}
          sx={{
            ...props.sx,
            mt: inputLabel ? 0.7 : 0,
            "& .MuiFormHelperText-root": {
              marginLeft: 0,
              marginRight: 0,
            },
          }}
          slotProps={{
            ...slotProps,
            input: {
              ...slotProps?.input,
              style: { gap: 8, display: "flex", alignItems: "center" },
              autoComplete: "off",
              sx: {
                borderRadius: 2,
              },
            },
            inputLabel: {
              required: requiredField,
              sx: {
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              },
            },
          }}
        />
        {tooltipTitle && (
          <Tooltip title={tooltipTitle} arrow>
            <InfolconIcon />
          </Tooltip>
        )}
      </Box>
    </FormControl>
  );
};

export default GKTextField;
